/* ==========================================================================
   日本ベッド トップページ改修 nb-top.js
   - ハンバーガー開閉
   - カテゴリ「さらに表示」アコーディオン
   - PICK UP / TOPIC のカルーセル（スクロール連動ドット・矢印）
   依存ライブラリなし
   ========================================================================== */
(function () {
   'use strict';

   /* ------------------------------------------------------------------
      FV確認モード
      ?fv=current|reference|legible|story|premium|compare で直接共有
      ?controls=0 で確認用スイッチャーを非表示
      ------------------------------------------------------------------ */
   var fv = document.getElementById('nbtFv');
   var fvSwitcher = document.getElementById('nbtFvSwitcher');
   var fvSwitcherNote = document.getElementById('nbtFvSwitcherNote');
   var fvCompare = document.getElementById('nbtFvCompare');
   var fvCompareRange = document.getElementById('nbtFvCompareRange');

   if (fv) {
      var fvModes = {
         current: '現在のFV',
         reference: '添付イメージ忠実',
         legible: '左側に白グラデーションを追加',
         story: 'ブランドストーリー＋品質訴求',
         premium: '金枠パネルのプレミアム型',
         compare: '中央のハンドルを左右にドラッグ'
      };
      var fvParams = new URLSearchParams(window.location.search);
      var fvInitial = fvParams.get('fv');

      if (!fvModes[fvInitial]) {
         fvInitial = fv.getAttribute('data-fv-mode');
      }
      if (!fvModes[fvInitial]) {
         fvInitial = 'reference';
      }

      function setFvMode(mode, updateUrl) {
         if (!fvModes[mode]) return;

         fv.setAttribute('data-fv-mode', mode);

         if (fvSwitcher) {
            Array.prototype.forEach.call(
               fvSwitcher.querySelectorAll('[data-fv-select]'),
               function (button) {
                  var active = button.getAttribute('data-fv-select') === mode;
                  button.classList.toggle('is-active', active);
                  button.setAttribute('aria-pressed', active ? 'true' : 'false');
               }
            );
         }

         if (fvSwitcherNote) {
            fvSwitcherNote.textContent = fvModes[mode];
         }

         if (updateUrl && window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('fv', mode);
            window.history.replaceState(null, '', url.pathname + url.search + url.hash);
         }
      }

      if (fvSwitcher) {
         if (fvParams.get('controls') === '0') {
            fvSwitcher.hidden = true;
         }

         Array.prototype.forEach.call(
            fvSwitcher.querySelectorAll('[data-fv-select]'),
            function (button) {
               button.addEventListener('click', function () {
                  setFvMode(button.getAttribute('data-fv-select'), true);
               });
            }
         );
      }

      if (fvCompare && fvCompareRange) {
         fvCompareRange.addEventListener('input', function () {
            fvCompare.style.setProperty('--nbt-fv-split', fvCompareRange.value + '%');
         });
      }

      setFvMode(fvInitial, false);
   }

   /* ------------------------------------------------------------------
      ABOUT US確認モード（FB#16,#17：寝室写真を大きく見せるパターン）
      ?about=current|photo で直接共有。FVと同じスイッチャーパネル内で切替
      ------------------------------------------------------------------ */
   var about = document.getElementById('nbtAbout');

   if (about) {
      var aboutModes = { current: true, photo: true };
      var aboutParams = new URLSearchParams(window.location.search);
      var aboutInitial = aboutParams.get('about');

      if (!aboutModes[aboutInitial]) {
         aboutInitial = about.getAttribute('data-about-mode');
      }
      if (!aboutModes[aboutInitial]) {
         aboutInitial = 'current';
      }

      var setAboutMode = function (mode, updateUrl) {
         if (!aboutModes[mode]) return;

         about.setAttribute('data-about-mode', mode);

         Array.prototype.forEach.call(
            document.querySelectorAll('[data-about-select]'),
            function (button) {
               var active = button.getAttribute('data-about-select') === mode;
               button.classList.toggle('is-active', active);
               button.setAttribute('aria-pressed', active ? 'true' : 'false');
            }
         );

         if (updateUrl && window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('about', mode);
            window.history.replaceState(null, '', url.pathname + url.search + url.hash);
         }
      };

      Array.prototype.forEach.call(
         document.querySelectorAll('[data-about-select]'),
         function (button) {
            button.addEventListener('click', function () {
               setAboutMode(button.getAttribute('data-about-select'), true);
            });
         }
      );

      setAboutMode(aboutInitial, false);
   }

   /* ------------------------------------------------------------------
      ハンバーガーメニュー
      ------------------------------------------------------------------ */
   var header = document.getElementById('nbtHeader');
   var burger = document.getElementById('nbtBurger');

   if (header && burger) {
      burger.addEventListener('click', function () {
         var open = header.classList.toggle('is-open');
         burger.setAttribute('aria-expanded', open ? 'true' : 'false');
         burger.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
      });
   }

   /* ------------------------------------------------------------------
      カテゴリ「さらに表示」（展開後に4カテゴリ）
      ------------------------------------------------------------------ */
   var catToggle = document.getElementById('nbtCatToggle');
   var catMore = document.getElementById('nbtCatMore');

   if (catToggle && catMore) {
      var catLabel = catToggle.querySelector('.nbt-cat-toggle-label');

      catToggle.addEventListener('click', function () {
         var open = catMore.classList.toggle('is-open');
         catToggle.classList.toggle('is-open', open);
         catToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
         if (catLabel) {
            catLabel.textContent = open ? '閉じる' : 'さらに表示';
         }
      });
   }

   /* ------------------------------------------------------------------
      カルーセル共通
      track  : スクロールコンテナ
      dots   : ドットの入れ物（null可）
      prev/next : 矢印ボタン（null可）
      ------------------------------------------------------------------ */
   function initCarousel(track, dots, prev, next) {
      if (!track) return;

      var items = Array.prototype.slice.call(track.children);
      if (!items.length) return;

      /* --- ドット生成 --- */
      var dotList = [];
      if (dots) {
         dots.innerHTML = '';
         items.forEach(function (item, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', (i + 1) + '枚目へ');
            b.addEventListener('click', function () {
               scrollToIndex(i);
            });
            dots.appendChild(b);
            dotList.push(b);
         });
      }

      function scrollToIndex(i) {
         var target = items[i];
         if (!target) return;
         track.scrollTo({
            left: target.offsetLeft - track.offsetLeft,
            behavior: 'smooth'
         });
      }

      /* --- 現在位置の算出（トラック中央にもっとも近いカード） --- */
      function currentIndex() {
         var center = track.scrollLeft + track.clientWidth / 2;
         var best = 0;
         var bestDist = Infinity;
         items.forEach(function (item, i) {
            var c = item.offsetLeft - track.offsetLeft + item.offsetWidth / 2;
            var d = Math.abs(c - center);
            if (d < bestDist) {
               bestDist = d;
               best = i;
            }
         });
         return best;
      }

      function sync() {
         var idx = currentIndex();

         dotList.forEach(function (b, i) {
            b.classList.toggle('is-active', i === idx);
         });

         /* 横スクロールが不要な幅（PCグリッド表示）ではドットを隠す */
         var scrollable = track.scrollWidth - track.clientWidth > 2;
         if (dots) {
            dots.style.display = scrollable ? '' : 'none';
         }

         if (prev) prev.disabled = !scrollable || track.scrollLeft <= 2;
         if (next) {
            next.disabled = !scrollable ||
               track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
         }
      }

      /* --- 矢印 --- */
      if (prev) {
         prev.addEventListener('click', function () {
            scrollToIndex(Math.max(0, currentIndex() - 1));
         });
      }
      if (next) {
         next.addEventListener('click', function () {
            scrollToIndex(Math.min(items.length - 1, currentIndex() + 1));
         });
      }

      /* --- スクロール／リサイズ監視 --- */
      var ticking = false;
      track.addEventListener('scroll', function () {
         if (ticking) return;
         ticking = true;
         window.requestAnimationFrame(function () {
            sync();
            ticking = false;
         });
      }, { passive: true });

      window.addEventListener('resize', sync);
      window.addEventListener('load', sync);
      sync();
   }

   /* PICK UP：SPのみ横スクロール＋矢印（PCは3カラムグリッドのため矢印・ドット非表示） */
   initCarousel(
      document.getElementById('nbtPickupTrack'),
      document.getElementById('nbtPickupDots'),
      document.getElementById('nbtPickupPrev'),
      document.getElementById('nbtPickupNext')
   );

   /* TOPIC：SP1カラム／PC2カラムの横スクロール＋矢印 */
   initCarousel(
      document.getElementById('nbtTopicTrack'),
      document.getElementById('nbtTopicDots'),
      document.getElementById('nbtTopicPrev'),
      document.getElementById('nbtTopicNext')
   );

})();
